export const SEARCH_FIELD_NAME: string = 'search'
